import { motion } from "framer-motion";
import { SITE } from "../config";

export const SiteFooter = () => {
  return (
    <footer id="footer" data-testid="site-footer" className="relative bg-[#0a0805] pt-24 md:pt-36 pb-12 overflow-hidden">
      <div className="pointer-events-none absolute inset-0" style={{ background: "radial-gradient(80% 90% at 50% 0%, rgba(216,171,78,0.12), transparent 60%)" }} />
      <div className="relative max-w-[1600px] mx-auto px-6 md:px-12">
        <div className="text-center max-w-3xl mx-auto">
          <motion.p initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6 }} className="font-grotesk uppercase tracking-[0.35em] text-xs text-[#d8ab4e] mb-6">
            Your Copy Awaits
          </motion.p>
          <motion.h2 initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6, delay: 0.1 }} className="font-display text-4xl sm:text-6xl leading-[0.95] mb-10">
            Begin your <span className="gold-text italic">New Golden Age</span>.
          </motion.h2>
          <motion.a
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.15 }}
            href={SITE.amazonUrl}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-buy-btn"
            className="group inline-flex items-center gap-2 bg-[#d8ab4e] text-[#0a0805] px-10 py-4 font-semibold uppercase tracking-widest hover:bg-[#f2c968] transition-colors"
          >
            {SITE.amazonLabel}
            <span className="inline-block transition-transform group-hover:translate-x-1.5">→</span>
          </motion.a>
        </div>

        <div className="mt-24 pt-8 border-t border-[#d8ab4e]/15 flex flex-col md:flex-row justify-between gap-4 text-xs uppercase tracking-[0.2em] text-[#7d7460]">
          <span className="font-display italic text-base normal-case tracking-normal gold-text">{SITE.title} — {SITE.author}</span>
          <span>© {new Date().getFullYear()} My Logic Legacy. All rights reserved.</span>
        </div>
      </div>
    </footer>
  );
};

export default SiteFooter;
